<p-toast></p-toast>

<p-sidebar [(visible)]="visible" position="right" [baseZIndex]="10000"
		   (onHide)="onHide()"
		   [style]="{width:'40em'}">
	<ng-template pTemplate="header">Image Library</ng-template>
	<div class="library-store-image-label">Logo</div>
	<img [src]="storeImageUrl" class="library-store-image-value"/>
	
	<div class="library-store-image-label" style="margin-top: 50px;">Store Cover Image</div>
	<img [src]="coverImageUrl" class="library-store-image-value"/>


</p-sidebar>
